import axios from '@/axiosInterceptor';

const state = () => ({
  collection: [],
  show: {},
});

const getters = {
  pendingRequestsCount: (state) => {
    const pendingConnections = state.collection.filter(
      (item) => item.status === 'pending'
    );
    if (!pendingConnections || pendingConnections.length < 1) return 0;
    return pendingConnections.length;
  },
};

// actions

const actions = {
  async getUserCompanyRequests({ commit }, query) {
    try {
      let res = await axios.get(
        process.env.API_IDENTITY + '/api/v1/user_company_requests',
        { q: query }
      );
      commit('setCollection', res.data);
      return res.data;
    } catch (e) {
      let status = e.response?.status;
      if (
        axios.isAxiosError(e) &&
        status &&
        [401, 403, 404, 422].includes(status)
      ) {
        return e.response;
      } else {
        throw e;
      }
    }
  },
  async getUserCompanyRequest({ commit }, id) {
    try {
      let res = await axios.get(
        process.env.API_IDENTITY + '/api/v1/user_company_requests/' + id
      );
      commit('setShow', res.data);
      return res.data;
    } catch (e) {
      let status = e.response?.status;
      if (
        axios.isAxiosError(e) &&
        status &&
        [401, 403, 404, 422].includes(status)
      ) {
        return e.response;
      } else {
        throw e;
      }
    }
  },
  async approveUserCompanyRequest({ commit, state }, { id, scopes }) {
    try {
      let res = await axios.patch(
        process.env.API_IDENTITY +
          '/api/v1/user_company_requests/' +
          id +
          '/approve',
        { scopes: scopes || ['onboarding'] }
      );
      let updatedCollection = state.collection.map((el) => {
        return el.id === res.data.id ? res.data : el;
      });
      commit('setCollection', updatedCollection);
      return res.data;
    } catch (e) {
      let status = e.response?.status;
      if (
        axios.isAxiosError(e) &&
        status &&
        [401, 403, 404, 422].includes(status)
      ) {
        return e.response;
      } else {
        throw e;
      }
    }
  },
  async rejectUserCompanyRequest({ commit }, id) {
    try {
      let res = await axios.patch(
        process.env.API_IDENTITY +
          '/api/v1/user_company_requests/' +
          id +
          '/reject'
      );
      commit('setShow', res.data);
      return res.data;
    } catch (e) {
      let status = e.response?.status;
      if (
        axios.isAxiosError(e) &&
        status &&
        [401, 403, 404, 422].includes(status)
      ) {
        return e.response;
      } else {
        throw e;
      }
    }
  },
};

//mutations
const mutations = {
  setCollection(state, data) {
    state.collection = data;
  },
  setShow(state, data) {
    state.show = data;
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
